import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { ScanResourcesListItem } from "../../../types";

const ScanResourcesTableNameCell = ({
  item: resource,
  ...cellProps
}: TableSimpleCellProps<ScanResourcesListItem>) => (
  <TableSimpleCell {...cellProps} role="rowheader">
    <TableCellText>{resource.name}</TableCellText>
  </TableSimpleCell>
);

export default ScanResourcesTableNameCell;
